import { render, staticRenderFns } from "./OrderTotalCosts.vue?vue&type=template&id=5cef56ef&"
import script from "./OrderTotalCosts.vue?vue&type=script&lang=js&"
export * from "./OrderTotalCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports